import { render, staticRenderFns } from "./Jitsi.vue?vue&type=template&id=7b0ba26a&scoped=true"
import script from "./Jitsi.vue?vue&type=script&lang=js"
export * from "./Jitsi.vue?vue&type=script&lang=js"
import style0 from "./Jitsi.vue?vue&type=style&index=0&id=7b0ba26a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0ba26a",
  null
  
)

export default component.exports